import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";

const ProfileState = (props) => {
  const ProfileStateSVG = () => {
    const themeDefault = useSelector((state) => state.themeDefault);

    const predefinedSizes = {
      small: themeDefault?.info?.newConfig?.emptyStateSizes?.small,
      medium: themeDefault?.info?.newConfig?.emptyStateSizes?.medium,
      large: themeDefault?.info?.newConfig?.emptyStateSizes?.large,
    };

    return (
      <svg
        width={predefinedSizes[props?.size] || 150}
        height={predefinedSizes[props?.size] || 150}
        viewBox="0 0 150 150"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1593_21694)">
          <path
            opacity="0.02"
            d="M120 53.8188V135.649C107.036 145.427 91.2387 150.717 75 150.717C58.7613 150.717 42.9645 145.427 30 135.649V53.8188C34.2435 53.8188 38.3131 52.1331 41.3137 49.1326C44.3143 46.132 46 42.0623 46 37.8188H104C104 42.0623 105.686 46.132 108.686 49.1326C111.687 52.1331 115.757 53.8188 120 53.8188Z"
            fill={themeDefault?.info?.colorPrimary}
          />
          <path
            opacity="0.08"
            d="M150 75.5488C150.01 87.194 147.304 98.681 142.096 109.097C136.888 119.512 129.322 128.57 120 135.549V53.5488C115.757 53.5488 111.687 51.8631 108.686 48.8625C105.686 45.862 104 41.7923 104 37.5488H46C46 41.7923 44.3143 45.862 41.3137 48.8625C38.3131 51.8631 34.2435 53.5488 30 53.5488V135.549C19.7726 127.878 11.6757 117.721 6.47817 106.041C1.28063 94.3607 -0.845023 81.546 0.303074 68.8134C1.45117 56.0808 5.8349 43.8531 13.038 33.2912C20.2411 22.7294 30.0244 14.1841 41.459 8.4668C52.8936 2.74951 65.5998 0.0500112 78.3711 0.62464C91.1425 1.19927 103.555 5.02895 114.43 11.75C125.305 18.4711 134.281 27.8605 140.507 39.0265C146.732 50.1925 150 62.7646 150 75.5488Z"
            fill={themeDefault?.info?.colorPrimary}
          />
          <path
            d="M75 54.5488C70.2533 54.5488 65.6131 55.9564 61.6663 58.5936C57.7195 61.2307 54.6434 64.979 52.8269 69.3644C51.0104 73.7499 50.5351 78.5755 51.4612 83.231C52.3872 87.8865 54.673 92.1629 58.0294 95.5194C61.3859 98.8759 65.6623 101.162 70.3178 102.088C74.9734 103.014 79.799 102.538 84.1844 100.722C88.5698 98.9054 92.3181 95.8293 94.9553 91.8825C97.5924 87.9357 99 83.2956 99 78.5488C99 72.1836 96.4714 66.0791 91.9706 61.5783C87.4697 57.0774 81.3652 54.5488 75 54.5488ZM75 63.3188C76.6831 63.3188 78.3285 63.8179 79.7279 64.753C81.1274 65.6881 82.2181 67.0172 82.8622 68.5722C83.5063 70.1272 83.6749 71.8383 83.3465 73.489C83.0181 75.1398 82.2076 76.6562 81.0175 77.8463C79.8273 79.0365 78.311 79.8469 76.6602 80.1753C75.0094 80.5037 73.2984 80.3351 71.7434 79.691C70.1884 79.0469 68.8593 77.9562 67.9242 76.5567C66.9891 75.1573 66.49 73.5119 66.49 71.8288C66.4927 69.5736 67.3904 67.4116 68.9861 65.8178C70.5817 64.224 72.7447 63.3288 75 63.3288V63.3188ZM75 99.8988C67.3 99.8988 61.06 96.3288 61.06 91.8988C61.06 87.4688 67.3 83.8988 75 83.8988C82.7 83.8988 88.93 87.4788 88.93 91.8988C88.93 96.3188 82.7 99.9088 75 99.9088V99.8988Z"
            fill={themeDefault?.info?.colorPrimary}
          />
          <path
            opacity="0.16"
            d="M91 111.549C91 112.344 90.6839 113.108 90.1213 113.67C89.5587 114.233 88.7957 114.549 88 114.549H62C61.2044 114.549 60.4413 114.233 59.8787 113.67C59.3161 113.108 59 112.344 59 111.549C59 110.753 59.3161 109.99 59.8787 109.428C60.4413 108.865 61.2044 108.549 62 108.549H88C88.7957 108.549 89.5587 108.865 90.1213 109.428C90.6839 109.99 91 110.753 91 111.549ZM97 120.549H53C52.2044 120.549 51.4413 120.865 50.8787 121.428C50.3161 121.99 50 122.753 50 123.549C50 124.344 50.3161 125.108 50.8787 125.67C51.4413 126.233 52.2044 126.549 53 126.549H97C97.7957 126.549 98.5587 126.233 99.1213 125.67C99.6839 125.108 100 124.344 100 123.549C100 122.753 99.6839 121.99 99.1213 121.428C98.5587 120.865 97.7957 120.549 97 120.549Z"
            fill={themeDefault?.info?.colorPrimary}
          />
        </g>
        <defs>
          <clipPath id="clip0_1593_21694">
            <rect
              width="150"
              height="150.13"
              fill="white"
              transform="translate(0 0.548828)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  };
  return <Icon component={ProfileStateSVG} />;
};

export default ProfileState;
